export function ensureVersion(version?: string): string {
  const normalized = (version || '').trim();
  return normalized.length > 0 ? normalized : '0.1.0';
}

export function ensureDateOnly(value?: string): string {
  const normalized = (value || '').trim();
  if (!normalized) {
    return new Date().toISOString().split('T')[0];
  }
  return normalized.split('T')[0].split(' ')[0];
}
